export default (itemDataProps, contentUnd, index = 0) => {
  const contentFr = contentUnd.replace(/und/, 'fr');
  const contentEn = contentUnd.replace(/und/, 'en');

  if (itemDataProps?.[contentUnd]?.[index] && itemDataProps?.[contentUnd]?.[index].length) {
    return itemDataProps?.[contentUnd]?.[index];
  } if (itemDataProps?.[contentFr]?.[index] && itemDataProps?.[contentFr]?.[index].length) {
    return itemDataProps?.[contentFr]?.[index];
  } if (itemDataProps?.[contentEn]?.[index] && itemDataProps?.[contentEn]?.[index].length) {
    return itemDataProps?.[contentEn]?.[index];
  }
  return '';
};
